import React, { useRef, useState } from 'react'
import { FibaInput, FibaTextArea, Form, GetCookie, ListScreen, SERVER_HOST, useFibaMsgBox, useLoading } from '../components'
import { GridColumn } from '@progress/kendo-react-grid'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Field } from '@progress/kendo-react-form'
import { PhotoIcon, XCircleIcon } from '@heroicons/react/24/outline'
import axios from 'axios'
import { TOKEN_NAME } from '../constants/token.const'
import { Rating } from '@progress/kendo-react-inputs'

const Usercomment = () => {
    const { t } = useTranslation()
    const gridRef = useRef(null);
    const [imagefile, setImageFile] = useState()
    const [show, setShowstate] = useState({ show: false, data: {} })
    const { showLoading } = useLoading()
    const { error, confirm } = useFibaMsgBox()

    const refreshData = () => {
        if (gridRef.current) {
            gridRef.current.readData()
        }
    }

    const createFunction = () => {
        setShowstate({ show: true, data: {} })
    }

    const detailFuncion = (data) => {
        setShowstate({ show: true, data })
    }

    const onClose = () => {
        setImageFile(null)
        setShowstate({ show: false, data: {} });
    }

    const onChangePicture = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            return;
        }
        setImageFile(e.target.files[0])
    }

    const removePicture = () => {
        setImageFile(null)
    }

    const onSubmit = async (data) => {
        const formData = new FormData();
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                formData.append(key, element);
            }
        }
        formData.append("image", imagefile);

        const isconfirm = await confirm(t('confirmsave'));
        if (isconfirm) {
            showLoading(true)
            axios.post(SERVER_HOST + "/api/v1/back/process", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + GetCookie(TOKEN_NAME),
                    'pc': show.data.id ? 'co000007' : 'co000006'
                },
                transformRequest: formData => formData,
            }).then((res) => {
                if (res.data.response_code === "RC000000") {
                    // setId(res.data.response)
                    onClose();
                    refreshData()
                } else {
                    error(t('cannot_upload'))
                    console.error(res.data);
                }
            }).catch((err) => {
                error(t('cannot_upload'))
                console.log(err);
            }).finally(() => {
                showLoading(false);
            })
        }
    }

    return (
        <div>
            <ListScreen
                read={'co000005'}
                delete={'co000008'}
                customFunction={createFunction}
                detailFuncion={detailFuncion}
                createable={false}
                customFunctionText={t('create')}
                userSendData={show.data}
                ref={gridRef}
            >
                <GridColumn field='name' title={t('name')} filter='text' />
                <GridColumn field='comment' title={t('comment')} filter='text' />
            </ListScreen>
            {show.show &&
                <Dialog
                    width={'80vw'}
                    height={'auto'}
                    title={t('detail')}
                    onClose={() => {
                        setShowstate({
                            show: false, data: {}
                        });
                        refreshData()
                    }}
                    className="px-0 pt-0"
                >
                    <Form
                        initialValues={show.data}
                        create={'co000006'}
                        update={'co000007'}
                        id={show.data.id}
                        afterRedirect={false}
                        onFinish={onClose}
                        onSubmit={onSubmit}
                    >

                        <div className='grid gap-4 md:grid-cols-2 sm:grid-cols-1'>
                            {show.data.id ? <div>

                            </div> : <div>
                                {!imagefile && <div>
                                    <input
                                        className='sr-only'
                                        accept="image/*"
                                        id={"fiba-file"}
                                        type={'file'}
                                        onChange={onChangePicture}
                                        name={'file_image'}
                                    />
                                    <label
                                        className='cursor-pointer k-input k-input-md k-rounded-md k-input-solid'
                                        htmlFor={"fiba-file"}
                                        style={{ width: '100px', height: '110px' }}
                                    >
                                        <div className='w-full pt-3 text-center text-gray-500'>
                                            <PhotoIcon className='w-12 h-12 mx-auto' />
                                            <div className='mt-3 text-xs'>
                                                {t('upload_photo')}
                                            </div>
                                        </div>
                                    </label>
                                </div>}
                                {
                                    imagefile && <div style={{ width: '100px', height: '110px' }} className='relative'>
                                        <div className='flex justify-center fiba-file-input'>
                                            <div className='m-auto'>
                                                <img
                                                    src={URL.createObjectURL(imagefile)} alt="upload"
                                                    className='w-full transition duration-300 ease-in-out hover:scale-105'
                                                    loading='lazy'
                                                />
                                            </div>
                                        </div>
                                        <div className="absolute cursor-pointer -top-3 -right-3">
                                            <XCircleIcon className='w-6 h-6 fill-white' onClick={removePicture} />
                                        </div>
                                    </div>
                                }
                            </div>}
                            <Field
                                name={'rating'}
                                component={Rating}
                                required={true}
                            />
                            <Field
                                name={'name'}
                                component={FibaInput}
                                label={"Хэрэглэгчийн нэр"}
                                required={true}
                            />
                            <Field
                                name={'name2'}
                                component={FibaInput}
                                label={"Хэрэглэгчийн нэр  /ENG/"}
                                required={true}
                            />

                            <Field
                                name={'productname'}
                                component={FibaInput}
                                label={"Бүтээгдэхүүний нэр"}
                                required={true}
                            />
                            <Field
                                name={'productname2'}
                                component={FibaInput}
                                label={"Бүтээгдэхүүний нэр  /ENG/"}
                                required={true}
                            />

                            <Field
                                name={'comment'}
                                component={FibaTextArea}
                                label={"Хэрэглэгчийн сэтгэгдэл"}
                                required={true}
                            />
                            <Field
                                name={'comment2'}
                                component={FibaTextArea}
                                label={"Хэрэглэгчийн сэтгэгдэл  /ENG/"}
                                required={true}
                            />
                        </div>
                    </Form>
                </Dialog>
            }
        </div>
    )
}

export default Usercomment